import React from 'react';
import { Link } from 'react-router-dom';
import { FaBell, FaArrowRight } from 'react-icons/fa';

import {
  Container,
  TaskButton,
  TaskButtonRows,
  TaskButtonTitle,
  TaskButtonRow,
  TaskButtonInfo,
} from './styles';

import { IProject } from '..';

interface IPendingProjectsProps {
  projects: IProject[];
}

const PendingProjects: React.FC<IPendingProjectsProps> = ({
  projects,
}: IPendingProjectsProps) => {
  const getItem = (projectReceived: IProject): string | undefined => {
    if (projectReceived.type === 'DISPLAY') {
      return `Item: ${projectReceived.display?.name}`;
    }
    if (projectReceived.type === 'MATERIAL') {
      return `Item: ${projectReceived.material?.name}`;
    }
    if (projectReceived.type === 'PATROCINIO') {
      return `Item: ${projectReceived.sponsorship?.name}`;
    }
    if (projectReceived.type === 'ADVERSIDADE') {
      return `Problema: ${projectReceived.adversity?.name}`;
    }
    if (projectReceived.type === 'PASTA') {
      return `Item: ${projectReceived.folder?.name}`;
    }
    if (projectReceived.type === 'EVENTO') {
      return `Tipo: ${projectReceived.event?.name}`;
    }

    return undefined;
  };

  const getPath = (recProject: IProject): string => {
    let sec_path = '';

    if (recProject.type === 'DISPLAY') sec_path = 'displays';
    if (recProject.type === 'MATERIAL') sec_path = 'materials';
    if (recProject.type === 'PATROCINIO') sec_path = 'sponsorships';
    if (recProject.type === 'ADVERSIDADE') sec_path = 'adversities';
    if (recProject.type === 'PASTA') sec_path = 'folders';
    if (recProject.type === 'AMOSTRA') sec_path = 'samples';
    if (recProject.type === 'EVENTO') sec_path = 'events';
    if (recProject.type === 'REBATE') sec_path = 'rebate';

    if (recProject.project_procedure.sequence && sec_path !== '') {
      return (
        `/projects/${sec_path}/procedure` +
        `${recProject.project_procedure.sequence}`
      );
    }

    return '/dashboard';
  };

  const getPendingProjects = (): React.ReactNode => {
    return projects?.map(project => (
      <Link
        to={{
          pathname: getPath(project),
          state: project,
        }}
      >
        <TaskButton isExtraVal={project.project_procedure.extra_validation}>
          <FaBell size={32} />
          <div>
            <TaskButtonTitle>
              Aviso de {project.project_procedure.description}
            </TaskButtonTitle>

            <TaskButtonRows>
              <TaskButtonRow>
                <TaskButtonInfo
                  isExtraVal={project.project_procedure.extra_validation}
                >
                  Tipo: {project.type}
                </TaskButtonInfo>
              </TaskButtonRow>

              <TaskButtonRow>
                <TaskButtonInfo
                  isExtraVal={project.project_procedure.extra_validation}
                >
                  Código: {project.code}
                </TaskButtonInfo>
              </TaskButtonRow>

              <TaskButtonRow>
                <TaskButtonInfo
                  isExtraVal={project.project_procedure.extra_validation}
                >
                  Cliente: {project.local_client.company_name}
                </TaskButtonInfo>
              </TaskButtonRow>

              <TaskButtonRow>
                <TaskButtonInfo
                  isExtraVal={project.project_procedure.extra_validation}
                >
                  {getItem(project)}
                </TaskButtonInfo>
              </TaskButtonRow>
            </TaskButtonRows>
          </div>
          <FaArrowRight size={20} />
        </TaskButton>
      </Link>
    ));
  };

  return <Container>{getPendingProjects()}</Container>;
};

export default PendingProjects;
